// PreviewTester/components/ScenarioTree.js
import React, { useState } from 'react';
import styles from './ScenarioTree.module.css';

const ScenarioTree = ({ scenarioTree, renderScenarioTree }) => {
  const [allCollapsed, setAllCollapsed] = useState(false);

  console.log(`scenarioTreeddddddd ${JSON.stringify(scenarioTree)}`)
  return (
    <div className={styles.scenarioTreeContainer}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
        <div className={styles.scenarioLabel}>🔄 Test Scenarios (Nested):</div>
        <button
          onClick={() => setAllCollapsed(!allCollapsed)}
          style={{
            backgroundColor: '#edf2f7',
            border: '1px solid #cbd5e0',
            borderRadius: '4px',
            padding: '2px 10px',
            fontSize: '11px',
            cursor: 'pointer',
            color: '#4a5568',
            fontWeight: '500',
          }}
        >
          {allCollapsed ? 'Expand All' : 'Collapse All'}
        </button>
      </div>
      <div className={styles.scenarioTree}>
        {renderScenarioTree(scenarioTree, 0, false, allCollapsed)}
      </div>
    </div>
  );
};

export default ScenarioTree;